import { twoButtonModalStyles as styles } from "@insite/content-library/Components/TwoButtonModal";

styles.submitButton = {
    ...styles.submitButton,
    color: "primary",
};
